import { USER } from 'constants/api';
import axios from 'utils/axios';

export const getUser = async (id) => {
    try {
        const result = await axios.get(`${USER.v1.fetchUser}/${id}`);
        return result.data;
    } catch (err) {
        throw new Error('Failed to fetch user');
    }
};

export const editUserInfo = async (data) => {
    const result = await axios.put(USER.v1.editUserInfo, data);
    return result.data;
};

export const getUsers = async (query) => {
    try {
        const result = await axios.get('/api/user', {
            params: { ...query.pagination, ...query }
        });
        return result.data;
    } catch (err) {
        throw new Error('Failed to fetch user');
    }
};

/**
 * Resends the activation email for an invited staff account.
 * @param {string} userId - Invited user identifier.
 * @returns {Promise<Object>} Invitation delivery confirmation.
 */
export const resendUserInvite = async (userId) => {
    const result = await axios.post(`/api/user/${encodeURIComponent(userId)}/resend-invite`);
    return result.data;
};
